/*
 *  公共接口
 *  xuzhongqi
 *  2020.12.29
 */

// 获取省市区级联
const getCascadeList = '/api_basedata/Areas/ListByCode'

// 图片，文件上传接口
const fileUpLoad  = 'http://fileyyy.hysyzs.com/Home/FileUpLoad'

// 个人中心，门店资质，首营，基本信息
// 获取当前用户的首营基本信息
const GetCustomerInfoZz = '/api_customers/Customer/GetCustomerInfoZz'

// 个人中心，门店资质，首营，资质
// 获取当前用户的首营信息
const GetQualifications = '/api_customers/Customer/GetQualifications'

// 个人中心，门店资质，首营，资质
// 提交，更新
const UpdateQualifications = '/api_customers/Customer/UpdateQualifications'

// 个人中心，门店资质，首营，资质
// 判断用户是否可以提交首营
const IsFirstOrder = '/api_customers/Customer/IsFirstOrder'

// 方法输出
export default {
	getCascadeList: getCascadeList,
	fileUpLoad: fileUpLoad,
	GetQualifications: GetQualifications,
	GetCustomerInfoZz: GetCustomerInfoZz,
	UpdateQualifications: UpdateQualifications,
	IsFirstOrder: IsFirstOrder
}
